import { FC, useState, useCallback } from 'react'
import { FocusinHandler } from 'handlers/FocusinHandler/FocusinHandler'
import { EditInPlaceInputController } from 'components/atoms/inputs/EditInPlaceInput/EditInPlaceInput'
import { FutureInputDecorationError } from 'components/features/future/FutureInputDecoration/FutureInputDecorationError'
import styles from 'components/features/future/LayerNameInput/LayerNameInput.styl'
import cn from 'classnames'
import { LAYER_NAME_MAX_LENGTH } from 'constants/future'

type LayerNameInputProps = {
  error?: string
}
export const LayerNameInput: FC<LayerNameInputProps> = (props) => {
  const { error } = props
  const [hasFocus, setHasFocus] = useState(false)
  const handleFocus = useCallback(() => setHasFocus(true), [])
  const handleBlur = useCallback(() => setHasFocus(false), [])

  const fieldClassName = cn(styles.field, {
    [styles.error]: !!error && !hasFocus,
    [styles.focus]: hasFocus,
  })

  return (
    <FocusinHandler onFocus={ handleFocus } onBlur={ handleBlur } className={ styles.layerNameInput }>
      <div className={ fieldClassName }>
        <EditInPlaceInputController name='name' maxLength={ LAYER_NAME_MAX_LENGTH } />
      </div>
      { error && (
        <div className={ styles.errorMessage }>
          <FutureInputDecorationError type={ error } />
        </div>
      )}
    </FocusinHandler>
  )
}
